<template>
  <div id="globalWallet">
    <header-nav :content="$t('pages_router_022')" />
    <div class="common-card-body">
      <div class="amount-total flex-align">
        <a-spin v-if="amountLoading" style="margin-left: 48px" />
        <div v-else>
          <div class="amount">{{ totalAmount }} USD</div>
          <div class="expliain">{{ $t('pages_wallet_001') }} ({{ $t('pages_wallet_002') }}{{ nowTime }})</div>
        </div>
      </div>
      <div class="table-part">
        <a-table
          :scroll="{ x: 890 }"
          :loading="loading"
          :pagination="false"
          :custom-header-row="() => { return {class: 'my-table-tr'}}"
          :columns="columns"
          :data-source="curList"
        >
          <template #headerCell="{ column }">
            <template v-if="column.key === 'freezeAmount'">
              <div class="flex-align">
                {{ column.title }}
                <a-tooltip :title="$t('pages_wallet_022')" placement="top">
                  <question-circle-filled class="ic-tip" />
                </a-tooltip>
              </div>
            </template>
          </template>
          <template #bodyCell="{ column, record }">
            <template v-if="column.key === 'currency'">
              <div class="flex-align table-cur">
                <img style="width: 21px; height: 13px" :src="getCountryLogo(record.currency)">
                <span style="margin-left: 12px">{{ record.currency }}</span>
                <span style="margin-left: 8px">{{ record.currencyName }}</span>
              </div>
            </template>
            <template v-else-if="column.key === 'edit'">
              <a-space style="justify-content: center; gap: 0px">
                <a-button size="small" type="link" @click="handleRecharge(record.currency)">{{ $t('pages_wallet_008') }}</a-button>
                <a-divider type="vertical" />
                <a-button size="small" type="link" @click="$router.push('/exchange/apply')">{{ $t('pages_wallet_009') }}</a-button>
                <a-divider type="vertical" />
                <a-button size="small" type="link" @click="$router.push('/funds/outbounds')">{{ $t('pages_wallet_010') }}</a-button>
                <!-- <a-divider type="vertical" />
                <a-button size="small" type="link" @click="$router.push('/funds/inbounds')">{{ $t('pages_wallet_011') }}</a-button> -->
              </a-space>
            </template>
          </template>
        </a-table>
      </div>
    </div>
    <a-modal
      wrap-class-name="recharge-detail"
      :visible="visible"
      :title="$t('pages_wallet_020')"
      :mask-closable="false"
      width="800px"
      @cancel="() => visible = false"
    >
      <a-tabs v-model:activeKey="activeTabKey" type="card">
        <!-- 法币银行 Tabs -->
        <a-tab-pane
          v-for="(bankInfo, index) in fiatBankInfos"
          :key="`bank-${index}`"
          :tab="`${$t('pages_wallet_025')} ${index + 1}`"
        >
          <div class="title">
            <info-circle-filled class="ic-info" />
            <span>{{ $t('pages_wallet_021') }}</span>
          </div>
          <div class="content">
            <div class="content-left">
              <div class="name">{{ $t('pages_wallet_012') }}:</div>
              <div class="name">{{ $t('pages_wallet_013') }}:</div>
              <div class="name">{{ $t('pages_wallet_014') }}:</div>
              <div class="name">{{ $t('pages_wallet_023') }}:</div>
              <div class="name">{{ $t('pages_wallet_015') }}:</div>
              <div class="name">{{ $t('pages_wallet_016') }}:</div>
              <div class="name">{{ $t('pages_wallet_017') }}:</div>
              <div class="name">{{ $t('pages_wallet_018') }}:</div>
              <div class="name">{{ $t('pages_wallet_019') }}:</div>
              <div class="name">{{ $t('pages_wallet_024') }}:</div>
            </div>
            <div class="content-right">
              <div class="name flex-align">
                <a-tooltip :title="bankName"><span class="area">{{ bankName }}</span></a-tooltip>
                <copy-outlined v-if="bankName" class="ic-copy" @click="copyToClipboard(bankName)" />
              </div>
              <div class="name flex-align">
                <a-tooltip :title="bankInfo.bankCountry"><span class="area">{{ bankInfo.bankCountry }}</span></a-tooltip>
                <copy-outlined v-if="bankInfo.bankCountry" class="ic-copy" @click="copyToClipboard(bankInfo.bankCountry)" />
              </div>
              <div class="name flex-align">
                <a-tooltip :title="bankInfo.swiftCode"><span class="area">{{ bankInfo.swiftCode }}</span></a-tooltip>
                <copy-outlined v-if="bankInfo.swiftCode" class="ic-copy" @click="copyToClipboard(bankInfo.swiftCode)" />
              </div>
              <div class="name flex-align">
                <a-tooltip :title="bankInfo.bankAddress"><span class="area">{{ bankInfo.bankAddress }}</span></a-tooltip>
                <copy-outlined v-if="bankInfo.bankAddress" class="ic-copy" @click="copyToClipboard(bankInfo.bankAddress)" />
              </div>
              <div class="name flex-align">
                <a-tooltip :title="bankInfo.bankAcctName"><span class="area">{{ bankInfo.bankAcctName }}</span></a-tooltip>
                <copy-outlined v-if="bankInfo.bankAcctName" class="ic-copy" @click="copyToClipboard(bankInfo.bankAcctName)" />
              </div>
              <div class="name flex-align">
                <a-tooltip :title="bankInfo.bankAcctCode"><span class="area">{{ bankInfo.bankAcctCode }}</span></a-tooltip>
                <copy-outlined v-if="bankInfo.bankAcctCode" class="ic-copy" @click="copyToClipboard(bankInfo.bankAcctCode)" />
              </div>
              <div class="name flex-align">
                <a-tooltip :title="bankInfo.bankBranchCode"><span class="area">{{ bankInfo.bankBranchCode }}</span></a-tooltip>
                <copy-outlined v-if="bankInfo.bankBranchCode" class="ic-copy" @click="copyToClipboard(bankInfo.bankBranchCode)" />
              </div>
              <div class="name flex-align">
                <a-tooltip :title="bankInfo.bankAcctNo"><span class="area">{{ bankInfo.bankAcctNo }}</span></a-tooltip>
                <copy-outlined v-if="bankInfo.bankAcctNo" class="ic-copy" @click="copyToClipboard(bankInfo.bankAcctNo)" />
              </div>
              <div class="name flex-align">
                <a-tooltip :title="bankInfo.merchantNo"><span class="area">{{ bankInfo.merchantNo }}</span></a-tooltip>
                <copy-outlined v-if="bankInfo.merchantNo" class="ic-copy" @click="copyToClipboard(bankInfo.merchantNo)" />
              </div>
              <div class="name flex-align">
                <a-tooltip :title="bankInfo.payeeAddress"><span class="area">{{ bankInfo.payeeAddress }}</span></a-tooltip>
                <copy-outlined v-if="bankInfo.payeeAddress" class="ic-copy" @click="copyToClipboard(bankInfo.payeeAddress)" />
              </div>
            </div>
          </div>
        </a-tab-pane>

        <!-- 加密货币钱包 Tabs -->
        <a-tab-pane
          v-for="(cryptoInfo, index) in cryptoWalletInfos"
          :key="`crypto-${index}`"
          :tab="`${$t('pages_wallet_026') || '数字钱包'} (${cryptoInfo.network.toUpperCase()})`"
        >
          <div class="title">
            <info-circle-filled class="ic-info" />
            <span class="warning">{{ $t('pages_wallet_027') }}</span>
          </div>
          <div class="crypto-content">
            <div class="crypto-item">
              <div class="crypto-label">{{ $t('pages_wallet_028') }}:</div>
              <div class="crypto-value flex-align">
                <span class="area">{{ cryptoInfo.network.toUpperCase() }}</span>
              </div>
            </div>
            <div class="crypto-item">
              <div class="crypto-label">{{ $t('pages_wallet_033') }}:</div>
              <div class="crypto-value flex-align">
                <a-tooltip :title="USDT">
                  <span class="area">USDT</span>
                </a-tooltip>
              </div>
            </div>
            <div v-if="false" class="crypto-item">
              <div class="crypto-label">{{ $t('pages_wallet_029') }}:</div>
              <div class="crypto-value flex-align">
                <a-tooltip :title="cryptoInfo.address">
                  <span class="area">{{ cryptoInfo.address }}</span>
                </a-tooltip>
                <copy-outlined class="ic-copy" @click="copyToClipboard(cryptoInfo.address)" />
              </div>
            </div>
            <div class="crypto-item">
              <div class="crypto-label">{{ $t('pages_wallet_029') }}:</div>
              <div class="crypto-value flex-align">
                <a-tooltip>
                  <span class="area">{{ $t('pages_wallet_038') }}</span>
                </a-tooltip>
              </div>
            </div>
            <!-- 待入账金额，cryptoInfo.usdtWaitInSum -->
            <div class="crypto-item pending-amount" :class="{ 'has-pending': cryptoInfo.usdtWaitInSum && Number(cryptoInfo.usdtWaitInSum) > 0 }">
              <div class="crypto-label">
                <clock-circle-outlined class="pending-icon" />
                {{ $t('pages_wallet_034') }}:
              </div>
              <div class="crypto-value flex-align">
                <span class="area pending-value" :class="{ 'blinking': cryptoInfo.usdtWaitInSum && Number(cryptoInfo.usdtWaitInSum) > 0 }">
                  {{ cryptoInfo.usdtWaitInSum ? cryptoInfo.usdtWaitInSum : '0.00' }} USDT
                </span>
                <a-badge
                  v-if="cryptoInfo.usdtWaitInSum && Number(cryptoInfo.usdtWaitInSum) > 0"
                  status="processing"
                  :text="$t('pages_wallet_037') || '处理中'"
                  class="pending-badge"
                />
              </div>
            </div>
            <div v-if="false" class="crypto-qr-code">
              <div class="qr-title">{{ $t('pages_wallet_030') || '扫描二维码进行充值' }}</div>
              <qr-code :text="cryptoInfo.address" :size="180" />
              <div class="qr-actions">
                <a-button
                  size="small"
                  type="link"
                  @click="downloadQRCode(cryptoInfo)"
                >
                  <download-outlined />
                  {{ $t('pages_wallet_031') || '下载二维码' }}
                </a-button>
              </div>
              <div class="qr-tip">{{ $t('pages_wallet_032') || '请使用支持该网络的钱包扫描' }}</div>
            </div>
          </div>
        </a-tab-pane>

        <!-- 兼容旧数据结构的银行转账 Tab -->
        <a-tab-pane
          v-if="fiatBankInfos.length === 0 && Object.keys(rechargeInfo).length > 0"
          key="bank-legacy"
          :tab="$t('pages_wallet_025') || '银行转账'"
        >
          <div class="title">
            <info-circle-filled class="ic-info" />
            <span>{{ $t('pages_wallet_021') }}</span>
          </div>
          <div class="content">
            <div class="content-left">
              <div class="name">{{ $t('pages_wallet_012') }}:</div>
              <div class="name">{{ $t('pages_wallet_013') }}:</div>
              <div class="name">{{ $t('pages_wallet_014') }}:</div>
              <div class="name">{{ $t('pages_wallet_023') }}:</div>
              <div class="name">{{ $t('pages_wallet_015') }}:</div>
              <div class="name">{{ $t('pages_wallet_016') }}:</div>
              <div class="name">{{ $t('pages_wallet_017') }}:</div>
              <div class="name">{{ $t('pages_wallet_018') }}:</div>
              <div class="name">{{ $t('pages_wallet_019') }}:</div>
              <div class="name">{{ $t('pages_wallet_024') }}:</div>
            </div>
            <div class="content-right">
              <div class="name flex-align">
                <a-tooltip :title="bankName"><span class="area">{{ bankName }}</span></a-tooltip>
                <copy-outlined v-if="bankName" class="ic-copy" @click="copyToClipboard(bankName)" />
              </div>
              <div class="name flex-align">
                <a-tooltip :title="rechargeInfo.bankCountry"><span class="area">{{ rechargeInfo.bankCountry }}</span></a-tooltip>
                <copy-outlined v-if="rechargeInfo.bankCountry" class="ic-copy" @click="copyToClipboard(rechargeInfo.bankCountry )" />
              </div>
              <div class="name flex-align">
                <a-tooltip :title="rechargeInfo.swiftCode"><span class="area">{{ rechargeInfo.swiftCode }}</span></a-tooltip>
                <copy-outlined v-if="rechargeInfo.swiftCode" class="ic-copy" @click="copyToClipboard(rechargeInfo.swiftCode)" />
              </div>
              <div class="name flex-align">
                <a-tooltip :title="rechargeInfo.bankAddress"><span class="area">{{ rechargeInfo.bankAddress }}</span></a-tooltip>
                <copy-outlined v-if="rechargeInfo.bankAddress" class="ic-copy" @click="copyToClipboard(rechargeInfo.bankAddress)" />
              </div>
              <div class="name flex-align">
                <a-tooltip :title="rechargeInfo.bankAcctName"><span class="area">{{ rechargeInfo.bankAcctName }}</span></a-tooltip>
                <copy-outlined v-if="rechargeInfo.bankAcctName" class="ic-copy" @click="copyToClipboard(rechargeInfo.bankAcctName)" />
              </div>
              <div class="name flex-align">
                <a-tooltip :title="rechargeInfo.bankAcctCode"><span class="area">{{ rechargeInfo.bankAcctCode }}</span></a-tooltip>
                <copy-outlined v-if="rechargeInfo.bankAcctCode" class="ic-copy" @click="copyToClipboard(rechargeInfo.bankAcctCode)" />
              </div>
              <div class="name flex-align">
                <a-tooltip :title="rechargeInfo.bankBranchCode"><span class="area">{{ rechargeInfo.bankBranchCode }}</span></a-tooltip>
                <copy-outlined v-if="rechargeInfo.bankBranchCode" class="ic-copy" @click="copyToClipboard(rechargeInfo.bankBranchCode)" />
              </div>
              <div class="name flex-align">
                <a-tooltip :title="rechargeInfo.bankAcctNo"><span class="area">{{ rechargeInfo.bankAcctNo }}</span></a-tooltip>
                <copy-outlined v-if="rechargeInfo.bankAcctNo" class="ic-copy" @click="copyToClipboard(rechargeInfo.bankAcctNo)" />
              </div>
              <div class="name flex-align">
                <a-tooltip :title="rechargeInfo.merchantNo"><span class="area">{{ rechargeInfo.merchantNo }}</span></a-tooltip>
                <copy-outlined v-if="rechargeInfo.merchantNo" class="ic-copy" @click="copyToClipboard(rechargeInfo.merchantNo)" />
              </div>
              <div class="name flex-align">
                <a-tooltip :title="rechargeInfo.payeeAddress"><span class="area">{{ rechargeInfo.payeeAddress }}</span></a-tooltip>
                <copy-outlined v-if="rechargeInfo.payeeAddress" class="ic-copy" @click="copyToClipboard(rechargeInfo.payeeAddress)" />
              </div>
            </div>
          </div>
        </a-tab-pane>

        <!-- 空状态 -->
        <a-tab-pane
          v-if="fiatBankInfos.length === 0 && cryptoWalletInfos.length === 0 && Object.keys(rechargeInfo).length === 0"
          key="empty"
          :tab="$t('pages_wallet_035') || '暂无数据'"
        >
          <div class="empty-content">
            <a-empty :description="$t('pages_wallet_036') || '暂无可用的充值方式'" />
          </div>
        </a-tab-pane>
      </a-tabs>

      <template #footer>
        <a-button
          type="primary"
          @click="() => visible = false"
        >{{ $t('common_text_024') }}</a-button>
      </template>

    </a-modal>
  </div>
</template>
<script>
import { reactive, toRefs, onUnmounted } from 'vue'
import { useStore } from 'vuex'
import HeaderNav from '@/components/header-nav'
import QrCode from '@/components/qr-code'
import { _pay, _home } from '@/api'
import i18n from '@/locale/index'
import moment from 'moment'
import { getCountryLogo, getTradeStatusName, copyToClipboard, parseMoney } from '@/util'
import QRCode from 'qrcode'
export default {
  name: 'GlobalWallet',
  components: {
    'header-nav': HeaderNav,
    'qr-code': QrCode
  },
  setup() {
    let timer = null
    const store = useStore()
    const state = reactive({
      loading: true,
      amountLoading: true,
      visible: false,
      activeTabKey: 'bank',
      bankName: '',
      bankCode: '',
      rechargeInfo: {},
      fiatBankInfos: [],
      cryptoWalletInfos: [],
      totalAmount: 0,
      nowTime: moment().format('YYYY-MM-DD HH:mm:ss'),
      curList: [],
      columns: [
        { key: 'currency', title: i18n.global.t('pages_wallet_003'), width: 180 },
        { key: 'amount', dataIndex: 'amountText', title: i18n.global.t('pages_wallet_004'), width: 150, ellipsis: true },
        { key: 'freezeAmount', dataIndex: 'freezeAmountText', title: i18n.global.t('pages_wallet_005'), width: 150, ellipsis: true },
        // { key: 'acctNo', dataIndex: 'acctNo', title: i18n.global.t('pages_wallet_006'), minWidth: 200, ellipsis: true },
        { key: 'refundingAmount', dataIndex: 'refundingAmountText', title: i18n.global.t('wallet_refunding_amount'), width: 150, ellipsis: true },
        { key: 'acctStatus', dataIndex: 'acctStatusText', title: i18n.global.t('pages_wallet_007'), ellipsis: true, width: 100 },
        { key: 'edit', title: i18n.global.t('common_text_001'), align: 'center', fixed: 'right', width: localStorage.getItem('locale-language') === 'en' ? 508 : 300 }
      ]
    })

    onUnmounted(() => {
      clearInterval(timer)
    })

    const handleRecharge = async (currency) => {
      state.visible = true
      state.activeTabKey = 'bank-0'
      state.rechargeInfo = {}
      state.fiatBankInfos = []
      state.cryptoWalletInfos = []

      const res = await _pay.getBankSuppDetail({ currency, bankCode: state.bankCode })

      if (res.data.succ && res.data.data) {
        // 设置法币银行信息
        if (res.data.data.fiatBankInfos && res.data.data.fiatBankInfos.length > 0) {
          state.fiatBankInfos = res.data.data.fiatBankInfos.map(item => ({
            ...item,
            merchantNo: store.getters.getUserInfo.merchantNo
          }))
          // 设置默认激活第一个法币银行 tab
          state.activeTabKey = 'bank-0'
        } else if (res.data.data.cryptoWalletInfos && res.data.data.cryptoWalletInfos.length > 0) {
          // 如果没有法币银行信息，默认激活第一个加密货币 tab
          state.activeTabKey = 'crypto-0'
        } else if (res.data.data.bankAcctNo) {
          // 兼容旧数据结构
          state.activeTabKey = 'bank-legacy'
        } else {
          state.activeTabKey = 'empty'
        }

        // 设置加密货币钱包信息
        if (res.data.data.cryptoWalletInfos && res.data.data.cryptoWalletInfos.length > 0) {
          state.cryptoWalletInfos = res.data.data.cryptoWalletInfos.map(item => ({
            ...item,
            merchantNo: store.getters.getUserInfo.merchantNo
          }))
        }

        // 兼容旧的数据结构
        if (res.data.data.bankAcctNo) {
          state.rechargeInfo = res.data.data
          state.rechargeInfo.merchantNo = store.getters.getUserInfo.merchantNo
        }
      }
    }

    const loadWalletRatio = async () => {
      state.amountLoading = true
      clearInterval(timer)
      const res = await _home.getWalletRatio()
      if (res.data.succ) {
        state.totalAmount = parseMoney(res.data.data)
        state.amountLoading = false
      } else {
        timer = setInterval(() => {
          loadWalletRatio()
        }, 5000)
      }
    }

    const loadRechargeSup = async () => {
      const res = await _pay.getRechargeSup()
      if (res.data.succ) {
        state.bankName = res.data.data.bankName
        state.bankCode = res.data.data.bankCode
      }
    }

    const loadCurList = async () => {
      state.loading = true
      const res = await _pay.getCurAccount()
      if (res.data.succ) {
        state.curList = res.data.data.map(item => {
          return Object.assign({}, item, {
            acctStatusText: getTradeStatusName(item.acctStatus, 'userStatus'),
            acctTypeText: getTradeStatusName(item.acctType, 'acctType'),
            amountText: item.amount ? parseMoney(item.amount, item.currency) : '0.00',
            totalAmountText: item.totalAmount ? parseMoney(item.totalAmount) : '0.00',
            freezeAmountText: item.freezeAmount ? parseMoney(item.freezeAmount) : '0.00',
            refundingAmountText: item.refundingAmount ? parseMoney(item.refundingAmount) : '0.00'
          })
        })
      }
      state.loading = false
    }

    const downloadQRCode = async (cryptoInfo) => {
      try {
        const dataUrl = await QRCode.toDataURL(cryptoInfo.address, {
          width: 256,
          margin: 2,
          color: {
            dark: '#000000',
            light: '#FFFFFF'
          }
        })

        const link = document.createElement('a')
        link.download = `${cryptoInfo.network.toUpperCase()}_QRCode_${Date.now()}.png`
        link.href = dataUrl
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      } catch (error) {
        console.error('Error downloading QR code:', error)
      }
    }

    loadCurList()
    loadWalletRatio()
    loadRechargeSup()

    return {
      ...toRefs(state),
      getCountryLogo,
      loadRechargeSup,
      handleRecharge,
      copyToClipboard,
      downloadQRCode
    }
  }
}
</script>
<style lang="less" scoped>
#globalWallet {
  .common-card-body {
    .amount-total {
      text-align: left;
      padding: 0 36px 12px 36px;
      height: 70px;
      .amount {
        font-size: 24px;
        font-weight: 600;
        color: @main-color;
      }
      .expliain {
        font-size: 12px;
        color: #333;
      }
    }
    .table-part {
      margin-top: 12px;
      .ic-tip {
        margin-left: 5px;
        font-size: 16px;
        color: @main-color;
      }
      .table-cur {
        font-weight: 500;
        color: @main-color;
      }
    }
  }
}
.recharge-detail {
  .ant-tabs-content-holder {
    padding-top: 16px;
  }

  .title {
    // 左右留白
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 20px;
    padding-left: 20px;
    padding-right: 20px;
    .flex-align;
    font-size: 15px;
    font-weight: 500;
    color: @main-color;
    margin: -12px 0 24px 0;
    .ic-info {
      font-size: 16px;
      margin-right: 5px;
      color: #ee252f;
    }
    .warning {
      color: #ee252f;
      font-size: 14px;
    }
  }

  .content {
    display: flex;
    overflow: hidden;
    .content-left {
      flex: 1;
      background: @table-th-color;
      padding: 0 15px;
      text-align: center;
      border-radius: 8px 0 0 8px;
      .name {
        height: 50px;
        line-height: 50px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .content-right {
      flex: 3;
      border: 1px solid #EFEFEF;
      border-radius: 0 8px 8px 0;
      overflow: hidden;
      .name {
        height: 50px;
        line-height: 50px;
        padding: 0 24px;
        border-bottom: 1px solid #EFEFEF;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        .area {
          flex: 20;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .ic-copy {
          color: @main-color;
          margin-left: auto;
          cursor: pointer;
          flex: 1;
        }
      }
      .name:last-child {
        border: 0;
      }
    }
  }

  .digital-wallet-content,
  .thirdparty-content,
  .empty-content {
    min-height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .crypto-content {
    padding: 20px;

    .crypto-item {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      padding: 15px;
      background: #f9f9f9;
      border-radius: 8px;
      border: 1px solid #e0e0e0;
      transition: all 0.3s ease;

      &.pending-amount {
        &.has-pending {
          background: linear-gradient(135deg, #fff7e6 0%, #fffbf0 100%);
          border: 1px solid #ffa940;
          box-shadow: 0 2px 8px rgba(255, 169, 64, 0.2);

          .pending-icon {
            color: #fa8c16;
            animation: pulse 2s infinite;
          }
        }
      }

      .crypto-label {
        width: 120px;
        font-weight: 500;
        color: @main-color;
        display: flex;
        align-items: center;
        gap: 6px;

        .pending-icon {
          font-size: 14px;
        }
      }

      .crypto-value {
        flex: 1;

        .area {
          flex: 1;
          word-break: break-all;
          margin-right: 10px;

          &.pending-value {
            font-weight: 600;

            &.blinking {
              color: #fa8c16;
              animation: blink 1.5s infinite;
            }
          }
        }

        .ic-copy {
          color: @main-color;
          cursor: pointer;
          font-size: 16px;
        }

        .pending-badge {
          margin-left: 12px;

          :deep(.ant-badge-status-dot) {
            animation: pulse-dot 1.5s infinite;
          }

          :deep(.ant-badge-status-text) {
            color: #fa8c16;
            font-size: 12px;
            font-weight: 500;
          }
        }
      }
    }

    .crypto-qr-code {
      margin-top: 30px;
      text-align: center;
      padding: 20px;
      background: #fff;
      border-radius: 12px;
      border: 1px solid #e8e8e8;

      .qr-title {
        font-size: 16px;
        font-weight: 600;
        color: @main-color;
        margin-bottom: 20px;
      }

      .qr-actions {
        margin-top: 15px;

        .ant-btn {
          color: @main-color;

          &:hover {
            color: @main-color;
          }
        }
      }

      .qr-tip {
        margin-top: 15px;
        font-size: 12px;
        color: #888;
        line-height: 1.4;
      }

      .qr-placeholder {
        padding: 60px 20px;
        background: #f5f5f5;
        border: 2px dashed #d9d9d9;
        border-radius: 8px;
        color: #999;
        font-size: 14px;
      }
    }
  }
}

@keyframes blink {
  0%, 50% { opacity: 1; }
  51%, 100% { opacity: 0.6; }
}

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.1); }
  100% { transform: scale(1); }
}

@keyframes pulse-dot {
  0% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.2); opacity: 0.8; }
  100% { transform: scale(1); opacity: 1; }
}
</style>

